import { useCallback, useState } from 'react'
import { ILaneCarrierMatchListFilterEnum } from 'types/graphqlTypes'

export interface IMatchingShipmentsFilters {
  matchTypes: ILaneCarrierMatchListFilterEnum[]
}

export type TMatchingShipmentsFiltersKey = keyof IMatchingShipmentsFilters

export type TMatchingShipmentsFilterSetter = <K extends keyof IMatchingShipmentsFilters>(
  key: K,
  value: IMatchingShipmentsFilters[K]
) => void

export interface IUseMatchingShipmentsFiltersResult {
  filters: IMatchingShipmentsFilters
  setFilter: TMatchingShipmentsFilterSetter
}

export const useMatchingShipmentsFilters = () => {
  const [filters, setFilters] = useState<IMatchingShipmentsFilters>({
    matchTypes: [],
  })

  const setFilter = useCallback(
    <K extends TMatchingShipmentsFiltersKey>(key: K, value: IMatchingShipmentsFilters[K]) =>
      setFilters(filters => ({ ...filters, [key]: value })),
    []
  )

  return {
    filters,
    setFilter,
  }
}
